<template>
  <div>
    <el-dialog :title="'企业微信扫码登录'" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false"
      @closed="handleDialogClose">
      <div class="content">
        <div class="left">
          <p>请使用企业微信扫描下方二维码</p>
          <!-- 企业微信二维码容器 -->
          <div id="wxqr-container">
          </div>
          <p v-if="statusText" class="status-text">{{ statusText }}</p>
        </div>
        <div class="right">
          <p>RAKUMART将获得以下权限</p>
          <div class="user">
            <p>获取您的企业微信账号信息</p>
            <p>授权后表示您已经同意 <a href="https://open.work.weixin.qq.com/wwopen/third/register/agreement" target="_blank"
                rel="noopener noreferrer">《企业微信服务协议》</a></p>
          </div>
          <p class="success">授权成功后，您可以使用企业微信扫码登录RAKUMART系统</p>
          <p class="tips"> <a href="javascript:void(0)" >如没有企业微信，<br/> 请联系义乌人事-李青</a></p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      show: false,
      statusText: '',
      timer: null,
      sceneId: '', // 用于轮询的唯一标识
      url: '',
    };
  },
  methods: {
    // 打开弹窗时初始化
    openDialog() {
      this.dialogVisible = true;
      this.show = false;
      this.statusText = '';
      this.generateQrCode();
    },
    // 生成企业微信登录二维码
    generateQrCode() {
      // 初始化登录组件
      // container.innerHTML = ''; // 清空容器
      let that = this
      const wwLogin = ww.createWWLoginPanel({
        params: {
          login_type: 'CorpApp',
          appid: 'ww79e73acf2785a242',
          agentid: '1000055',
          redirect_uri: 'https://manage.rakumart.com',
          redirect_type: 'callback',
          // disable_quick_login: 'true',
        },
        onCheckWeComLogin({ isWeComLogin }) {
          console.log(isWeComLogin)
        },
        onLoginSuccess({ code }) {
          // 获取绑定state
          that.$api.getState().then(res => {
            let datas = {
              code,
              state: res.data.state
            }
            //企业微信绑定提交接口
            that.$api.bindWx(datas).then(res => {
              that.$message.success(res.msg)
              that.dialogVisible = false
              that.handleDialogClose()
              location.href = 'https://manage.rakumart.com/#/login'
            })
          })
          console.log({ code }, '成功')
        },
        onLoginFail(err) {
          console.log(err, '失败')
        },
      })
      // 显示企业微信扫码
      this.$nextTick(() => {
        const container = document.getElementById('wxqr-container');
        container.appendChild(wwLogin.el)

      })
      // console.log(wwLogin.el);
    },
    // 弹窗关闭时清理
    handleDialogClose() {
      const container = document.getElementById('wxqr-container');
      const iframe = document.querySelector('iframe');
      container.removeChild(iframe)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 20px 53px 40px;
  display: flex;

  .left {
    width: 300px;
    border-right: 1px solid #ccc;
    padding-right: 40px;
    text-align: center;

    p {
      font-size: 16px;
      margin: 0px 0 20px;
      text-align: center;
    }

    #wxqr-container {

      display: flex;
      justify-content: center;
      margin: 0 auto;
      height: 400px;
      overflow: hidden;
    }

    .status-text {
      color: #409EFF;
      font-size: 14px;
      margin-top: 10px;
    }
  }

  .right {
    flex: 1;
    padding: 0 25px 0 60px;

    p {
      margin-bottom: 20px;
      font-size: 16px;
    }

    .user {
      margin-top: 70px;

      p {
        margin-bottom: 10px;
        font-size: 14px;
      }
    }

    .success {
      color: #999;
      margin-top: 40px;
      margin-bottom: 0;
    }
    .tips{
      margin-top: 20px;
      font-size: 22px;
      line-height: 35px;
    }
    a {
      color: #B4272D;
    }
  }
}

/deep/ .el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #D8D8D8;
}
</style>
